import { useEffect, useState } from "react";
import api from "../../../shared/utils/request";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const CategoryBanners = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await api.get("customer/categories");
        setCategories(data?.data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <section className="promotional-banner pt-80">
      <div className="container container-lg">
        <div className="position-relative gradient-shadow">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={1.2}
            spaceBetween={20}
            loop={true}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            breakpoints={{
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            className="row gy-4 g-0"
          >
            {categories?.map((category, index) => (
              <SwiperSlide key={index} className="h-auto">
                <div className="promotional-banner-item position-relative rounded-24 overflow-hidden z-1 py-52 ps-40 pe-24 h-100">
                  <img
                    src={category?.category_image}
                    alt={category?.name}
                    className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 object-fit-cover z-n1"
                  />
                  <div className="promotional-banner-item__content">
                    <h6 className="promotional-banner-item__title text-2xl max-w-184">
                      {category?.name}
                    </h6>
                    <div className="d-flex align-items-end gap-8">
                      <span className="text-heading fst-italic text-sm">
                        {category?.description}
                      </span>
                    </div>
                    <Link
                      to={`/collections/category/${category?.slug}`}
                      className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8 mt-24"
                    >
                      Shop Now
                      <span className="icon text-xl d-flex">
                        <i className="ph ph-arrow-right" />
                      </span>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};
export default CategoryBanners;
